import ReactDOM from 'react-dom';

export default ReactDOM.unstable_batchedUpdates || ((fn) => fn());
